import gql from 'graphql-tag';

export const QUERY_LISTA_SOLICITUDES = gql(`
query listaSolicitudes($criteria: ItemCriteriaInput, $idioma: String) {
    listaSolicitudes (criteria: $criteria) {
        totalElements
        results {
            token
            fechaAlta
            idLegalDeudor
            estado
            literalSolicitudTipo(idioma: $idioma) {
                valor
            } 
            literalSolicitudEstado(idioma: $idioma) {
                valor
                clave
                codigo
            }
        }
    }
  }
`);

export const ALTA_SOLICITUD_REQUEST_INPUT = gql(`
    mutation altaSolicitudRequestInput ($input: AltaSolicitudRequestInput, $idioma: String) {
        altaSolicitud(altaSolicitudRequest: $input) {
            fechaAlta
            estado
            token
            idLegalDeudor
            clienteIdLegal
            justificacion
            motivoRechazo
            fechaEstado
            origen
            tipo
            deudasSolicitudResponse {
                cnaeAcreedor
                origenDeuda
                literalOrigenDeudaDetalle(idioma: $idioma) {
                    clave
                    valor
                }  
                literalTipoCnae(idioma: $idioma) {
                    clave
                    valor
                }  
                importePendiente
                fechaVencimientoPrimerImpago
                fechaPublicacion
                deudaJudicializada
                tokenExpediente
                importeImpagadoEnAlta
                fechaVencimientoUltimoImpago
            }
        }
    }
`);

export const GET_SOLICITUD_BY_TOKEN = gql(`
   query getSolicitudByToken ($token: String) {
      getSolicitudByToken(token: $token) {
         fechaAlta
         estado
         token
         idLegalDeudor
         clienteIdLegal
         justificacion
         motivoRechazo
         fechaEstado
         origen
         tipo
      }
   }
`);